import { render, staticRenderFns } from "./NoteEditorComponent.vue?vue&type=template&id=7ae316ec&scoped=true"
import script from "./NoteEditorComponent.vue?vue&type=script&lang=js"
export * from "./NoteEditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae316ec",
  null
  
)

export default component.exports